import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { useCreateTrip } from "@/hooks/useTrip";
import { PageShell } from "@/components/PageShell";
import { BrandHeader } from "@/components/BrandHeader";
import { Button } from "@/components/Button";
import { TextInput } from "@/components/TextInput";
import { CurrencyPicker } from "@/components/CurrencyPicker";
import { Stack } from "@/components/Stack";
import { useToast } from "@/components/toast/ToastProvider";
import type { Currency } from "@/api/types";
import "./create-trip.css";

export function CreateTripScreen() {
  const [name, setName] = useState("");
  const [ccy, setCcy] = useState<Currency>("UAH");
  const navigate = useNavigate();
  const toast = useToast();
  const create = useCreateTrip();

  const canSubmit = name.trim().length > 0 && !create.isPending;

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (!canSubmit) return;
    create.mutate(
      { name: name.trim(), settlement_ccy: ccy },
      {
        onSuccess: (trip) =>
          navigate(`/t/${trip.trip_id}/created`, { replace: true }),
        onError: () =>
          toast.push({
            tone: "error",
            title: "Не вдалось створити. Спробуй ще раз.",
          }),
      },
    );
  }

  return (
    <PageShell header={<BrandHeader />}>
      <section className="wp-create" aria-labelledby="create-trip-title">
        <h1 id="create-trip-title" className="wp-create__title">
          Нова поїздка
        </h1>
        <form onSubmit={handleSubmit}>
          <Stack gap={5}>
            <TextInput
              label="Назва"
              value={name}
              onChange={(e) => setName(e.currentTarget.value)}
              placeholder="Лісабон 2026"
              autoFocus
              required
              data-testid="trip-name-input"
            />
            <CurrencyPicker
              label="Валюта для розрахунків"
              value={ccy}
              onChange={setCcy}
              hint="У цій валюті будуть всі баланси та перекази. Кожен чек може бути у своїй валюті — курси підставимо самі."
            />
            <Button
              type="submit"
              size="lg"
              fullWidth
              disabled={!canSubmit}
              loading={create.isPending}
              data-testid="create-trip-submit"
            >
              Створити
            </Button>
            <p className="wp-create__trust">
              Нікого реєструвати не треба. Створимо одне посилання — поділишся
              у чаті, і всі мають доступ.
            </p>
          </Stack>
        </form>
      </section>
    </PageShell>
  );
}
